import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 THE FREELANCE PROPOSAL MACHINE™',
  subtitle: '100+ AI Prompts & Workflows to Build Better Proposals, Define Project Scope & Win Client Opportunities',
  was: '$54 USD',
  now: '27',
  features: ['The Complete 6-Volume Proposal System', '100 Structured AI Prompts Across Six Volumes', 'Copy-and-Customize Prompt Frameworks', 'Practical Workflow and Quality-Control Guidance', 'The Freelance Proposal Template Vault™', 'The Client Follow-Up Message Vault™', 'The Project Scope Checklist Pack™', 'The Client Discovery Question Bank™', 'The 7-Day Proposal Workflow Quick-Start™', 'Digital PDF Access'],
  cta: 'Get instant access'
};
const trust = [{
  icon: LockIcon,
  label: 'Secure Checkout'
}, {
  icon: ZapIcon,
  label: 'Digital Access'
}, {
  icon: BookOpenIcon,
  label: '6 Volumes + 5 Bonuses'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-116" data-mp="3vyxdgh76ounh">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "17px",
      paddingBottom: "12px"
    }} data-id="element-117" data-mp="4v8kqmww2dff">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-118" data-mp="er1ujyj83sti">
          <p className="font-display text-2xl font-black text-plum" data-id="element-119" data-mp="eqjzh58arkn6">💰 Get the 6-in-1 system today</p>
          
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/40 bg-white px-6 pb-6 text-center shadow-[0_0_0_4px_rgba(0,112,255,0.06),0_24px_60px_-28px_rgba(0,112,255,0.55)]" data-id="element-120" data-mp="3i81ziqhtvnd1">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] border-b-2 border-grape-soft bg-plum px-6 py-3" data-id="element-121" data-mp="2rglansogvt93">
            <h3 className="font-display text-base font-black text-white" data-id="element-122" data-mp="2mibfhi2qssnh">{plan.name}</h3>
          </div>
          <p className="text-xs font-semibold text-plum/70" data-id="element-123" data-mp="316xrb9t5v29y">{plan.subtitle}</p>

          <div className="mt-6" data-id="element-124" data-mp="2w7uwsjat4eg8">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-125" data-mp="2w8mi91aowvss">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-126" data-mp="28j1vs8fbvger">
              <span className="relative inline-block font-display leading-none" data-id="element-127" data-mp="23ixi0q5t0zs8">
                <span className="absolute right-full top-2 mr-1 text-[36px] font-black leading-none text-grape" data-id="element-128" data-mp="23la67l25o6dq">$</span>
                <span className="text-grape-shine text-[78px] font-black leading-none" data-id="element-129" data-mp="2dhd7ypt3i305">{plan.now}</span>
                <span className="absolute left-full bottom-2 ml-2 text-base font-black leading-none text-plum" data-id="element-130" data-mp="3tv3e023rz1cf">USD</span>
              </span>
            </div>
            <p className="mt-1 text-xs font-bold uppercase text-grape-deep" data-id="element-131" data-mp="3ovz75i4bpfp9">You save $27 USD — 50% OFF</p>
            <p className="mt-2 text-xs font-semibold text-plum/70" data-id="element-132" data-mp="cgjxzyaiwzv">
              One-time payment · No recurring subscription for this purchase
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-133" data-mp="3ng4tjwajkeuj">
              · Payment will be processed in your local currency ·
            </p>
          </div>

          <p className="mt-6 w-full text-left text-xs font-black uppercase tracking-wider text-plum" data-id="element-134" data-mp="j0d7p6nj2wj9">
            🎯 Your complete digital package includes:
          </p>
          <ul className="mt-3 w-full flex-1 space-y-2.5 text-left" data-id="element-135" data-mp="o1sub35ctb3r">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-136" data-mp="a6qnmdsonhpw">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-137" data-mp="e825fx5beynj" />
                {f}
              </li>)}
          </ul>

          <p className="mt-6 text-sm text-plum/70" data-id="element-138" data-mp="16qzfqxxj8gt9">
            Get the complete system and start building a more organized approach to preparing freelance proposals.
          </p>

          <div className="mt-5 flex w-full justify-center" data-id="element-139" data-mp="3a8fhgswzy0ip">
            <CTAButton size="md" data-id="element-140" data-mp="3a74a6j4ceamu">{plan.cta}</CTAButton>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/60" data-id="element-141" data-mp="35adw21c3lp42">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="1rkkfu2vracj">
                <Icon className="h-4 w-4 text-grape" aria-hidden="true" data-id="element-143" data-mp="3syezivuf6fcm" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 w-full max-w-2xl rounded-2xl bg-plum p-6 text-center text-white sm:p-8" data-id="element-144" data-mp="3o6dthrnuhkv1">
          <ShieldCheckIcon className="mx-auto h-10 w-10 text-grape-soft" aria-hidden="true" data-id="element-145" data-mp="3k4sikbuvfgnh" />
          <p className="mt-3 text-xs font-bold uppercase tracking-[0.2em] text-grape-soft" data-id="element-146" data-mp="kl829dwcd7tm">🛡️ Your 7-day money-back guarantee</p>
          <h3 className="mt-2 font-display text-xl font-black sm:text-2xl" data-id="element-147" data-mp="1yfera18gut5r">
            Try The Freelance Proposal Machine™ with confidence
          </h3>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/75" data-id="element-148" data-mp="23ehxvq43h7fu">
            Your purchase is covered by a 7-day money-back guarantee. Explore the materials, review the prompts, and
            determine whether the system fits your freelance workflow. If you're not satisfied with your purchase, contact
            our support team within 7 days of purchase and request a refund in accordance with the applicable refund policy.
          </p>
          
        </div>
      </div>
    </section>;
}